import { useContext, useEffect, useState } from 'react';
import '../styles/ProductDetails.css'
import SpinnerLoader from '../components/SpinnerLoader';
import DetailsHeader from '../components/DetailsHeader';
import ProductDetailsSection from '../components/ProductDetailsSection';
import ProductDetailsSectionInfo from '../components/ProductDetailsSectionInfo';
import ProductActionSection from '../components/ProductActionSection';
import * as language from '../constants/languages';
import { useParams } from 'react-router-dom';
import { getProductDetails } from '../services/services';
import { AuthContext } from './RootPage';

export default function ProductDetailsPage() {
    let mediaQueryList = window.matchMedia("(max-width: 992px)");
    let { product_id } = useParams()

    const { getCompanyId, getBranchId} = useContext(AuthContext);
	const companyidValue = getCompanyId()
	const branchId = getBranchId()

    const [isLoading, setisLoading] = useState(true)
    const [productDetails, setproductDetails] = useState()
    const [productData, setproductData] = useState([])
    const [SpecificationCheck, setSpecificationCheck] = useState('')
   
    const [qty, setqty] = useState(0)
    const [isMobile, setisMobile] = useState(mediaQueryList.matches)
    const qtyChangeEvent = (data) => {
        if (data.token != 2) {
            getCartDetails();
        }
    }
    useEffect(() => {
        getProductDetailsLoader()
        isSpecification();
        // window.addEventListener('productQtyChange', qtyChangeEvent)
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener("change", checkDevice)
        }
        else {
            mediaQueryList.addListener(checkDevice)
        }
        return () => {
            if (mediaQueryList.addEventListener) {
                mediaQueryList.removeEventListener("change", checkDevice)
            }
            else {
                mediaQueryList.removeListener(checkDevice)
            }
            // window.removeEventListener('productQtyChange', qtyChangeEvent)
            mediaQueryList.removeEventListener("change", checkDevice)
        }
    }, [])

    //check for Specification tab hide
    async function isSpecification() {
        var spec = sessionStorage.getItem('show_specification')
        setSpecificationCheck(spec)
    }

    // get product details
    async function getCartDetails() {
        const cart = sessionStorage.getItem('cartItems');
        const details = productDetails
        let cartItems
        if (details.status === "success") {
            if (cart) {
                cartItems = JSON.parse(cart);
                const elementsIndex = cartItems.customerCartItems.findIndex(element => element.product.productId == product_id);
                if (elementsIndex != -1) {
                    details.data.cartQty = cartItems.customerCartItems[elementsIndex].qty
                    setqty(cartItems.customerCartItems[elementsIndex].qty)
                }
                else {
                    setqty(0)
                }
                setproductData({...details.data})
                setisLoading(false)
            } else {
                setproductData({...details.data})
                setisLoading(false)
                setqty(0)
            }
        } else {
            setisLoading(true)
        }
    }

    const getProductDetailsLoader = async () => {
        try {
            const token = sessionStorage.getItem('access_token');
            const productDetailsResponse = await getProductDetails(companyidValue, product_id, branchId, token).catch((error) => { return error })
            setproductDetails({...productDetailsResponse})
        } catch (error) {

        }
    }


    function checkDevice(mql) {
        setisMobile(mql.matches)
    }

    useEffect(() => {
        if (productDetails) {
            getCartDetails()
        }
    }, [productDetails])

    return (
        <div >
            {
                isMobile &&
                <DetailsHeader />
            }
            <div >
                {
                    isLoading == true ?
                        <SpinnerLoader />
                        :
                        <div className='product-details-container'>
                            <div>
                                <ProductDetailsSection
                                    productData={productData}
                                />
                                <ProductActionSection
                                    cartQny={qty}
                                    cartUnit={productData.unit != '-- None --' ? productData.unit : null}
                                    productData={productData}
                                />
                            </div>
                            <ProductDetailsSectionInfo
                                productData={productData}
                                isSpecification={SpecificationCheck}
                            />


                        </div>
                }
            </div>


        </div>


    )
}